// extracted by mini-css-extract-plugin
export default {"card":"styles_card__Pkjly","wrapperTable":"styles_wrapperTable__VHKFZ","rowPointer":"styles_rowPointer__7S2J6","header":"styles_header__9u36P"};